export default "__VITE_ASSET__Be8AcXCK__"